import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  listing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  quotationSettings: {
    // Note that the levels are Agency -> Quotation -> Individual Quotation State
    // This is the 2nd level state (Quotation)
    init: 0,
    initErr: [],
    menu: {},
    intermediaries: [],
    isStaff: undefined
  },
  quotation: {
    // Module level init, brings in menu for specific modules
    init: 0,
    menu: {},
    saving: false,
    saveError: {
      fieldMessages: [],
      messages: []
    },
    // Quotation Life Cycle state. Controls the steps within the quotation/proposal. Starts off as 1 but 0 is reserved for salesOppo.
    quoteLifeCycle: 0,
    promptWhenExit: true,
    commonInfo: {
      // Currently hardcode to S$ until the day we need localisation for other country
      currPrefix: 'S$',
      statusCode: undefined,
      statuses: [],
      audits: [],
      commsLogs: [],
      paymentHistory: [],
      polNo: undefined,
      proposalRefNo: undefined,
      paid: undefined,
      premium: {
        init: 0,
        initErr: [],
        premDue: undefined,
        discPct: undefined,
        discPctMax: undefined,
        discAmt: undefined,
        netPremDue: undefined,
        gstRate: undefined,
        gstAmt: undefined,
        premiumPayable: undefined,
        billPremiumPayable: undefined,
        commGN: undefined,
        commRate: undefined,
        commRateMax: undefined,
        commAmt: undefined,
        protDisc: undefined,
        protComm: undefined,
        inclGst: undefined,
        benefits: [],
        promotion: undefined
      }
    },
    queryInfo: {
      // To store description field (solely for query purpose - onload query value)
      // For description value during entry, get from param
      intermediary: undefined,
      finInst: undefined,
      product: undefined,
      scheme: undefined,
      duration: undefined,
      appCountry: undefined,
      mailCountry: undefined,
      busCls: undefined,
      tariff: undefined,
      cover: undefined,
      vehUsg: undefined,
      vehMake: undefined,
      vehModel: undefined,
      vehBodyType: undefined,
      vehCapacity: undefined,
      vehTonnage: undefined,
      vehNoSeats: undefined,
      mtrPlan: undefined,
      statistics: [],
      excess: [],
      permStatuses: [],
      comdty: undefined,
      pack: undefined,
      convy: undefined,
      vesName: undefined,
      grt: undefined,
      nrt: undefined,
      voyDet: undefined,
      voyDateType: undefined,
      voyArea: undefined,
      portFrom: undefined,
      portTo: undefined,
      surveyAgt: undefined,
      settlingAgt: undefined,
      csgnCountry: undefined,
      crgoCover: undefined,
      clauses: [],
      constrnCls: undefined,
      occupancy: undefined,
      limitsText: [],
      travelArea: undefined,
      appIDs: [],
      campaign: undefined,
      promotion: undefined,
      discLdg: []
    },
    commonForm: {
      // Fields here should be proposal level variables
      proposalNo: undefined,
      revision: undefined,
      appID: undefined,
      intermediary: undefined,
      salesOppName: undefined,
      salesOppEmail: undefined,
      salesOppPhone: undefined,
      product: undefined,
      scheme: undefined,
      duration: undefined,
      startDate: undefined,
      endDate: undefined,
      billCurr: undefined,
      billCurrRate: undefined,
      applicant: {
        appIntStat: undefined,
        appSalutation: undefined,
        appName: undefined,
        appNationality: undefined,
        appNricPassport: undefined,
        appDob: undefined,
        appOccupation: undefined,
        appGender: undefined,
        appEmail: undefined,
        appMobileNo: undefined,
        appTelNo1: undefined,
        appTelNo2: undefined,
        appFaxNo: undefined,
        appPostalCode: undefined,
        appAdd1: undefined,
        appAdd2: undefined,
        appAdd3: undefined,
        appAdd4: undefined,
        appState: undefined,
        appCountry: undefined,
        mailAdd: undefined,
        mailPostalCode: undefined,
        mailAdd1: undefined,
        mailAdd2: undefined,
        mailAdd3: undefined,
        mailAdd4: undefined,
        mailState: undefined,
        mailCountry: undefined,
        coyName: undefined,
        coyName2: undefined,
        coyRocUen: undefined,
        coyNature: undefined,
        appIsDrv: undefined,
        appIsStudent: undefined,
        appIsInsured: undefined,
        appJointApplicant: undefined,
        appEmployerName: undefined,
        appJointScheme: undefined
      },
      acceptDate: undefined,
      finInst: undefined,
      optCvr: [],
      discLdg: [],
      paytMode: undefined,
      paytCCNo: undefined,
      paytCCName: undefined,
      paytCCType: undefined,
      paytCCExpMth: undefined,
      paytCCExpYr: undefined,
      paytCCCvv: undefined,
      paytInstalmentPlan: undefined,
      quotationType: undefined,
      masterProposalNo: undefined,
      campaign: undefined,
      promotion: undefined,
      adjDiscount: undefined
    },
    motorForm: {
      // Fields here should be risk level and below
      busCls: undefined,
      tariff: undefined,
      cover: undefined,
      exClm: undefined,
      noClm: undefined,
      clmAmt: undefined,
      ncdRate: undefined,
      ncdPct: undefined,
      drivers: [],
      vehRegNo: undefined,
      vehUsg: undefined,
      vehMake: undefined,
      vehModel: undefined,
      vehManuYr: undefined,
      vehValue: undefined,
      vehRegYr: undefined,
      vehRegMth: undefined,
      maxLaden: undefined,
      unLaden: undefined,
      calcTonnage: undefined,
      mtrPlan: undefined,
      exInsurer: undefined,
      exPolNo: undefined,
      exPolNoExp: undefined,
      engineNo: undefined,
      chassisNo: undefined,
      statistics: [],
      excess: [],
      addBenefits: undefined
    },
    motorParam: {
      // We will use this flag to determine if we should load params onLoad
      generalLoaded: false,
      vehicleLoaded: false,
      product: [],
      busCls: [],
      tariff: [],
      cover: [],
      ncdRate: [],
      permStatuses: [],
      vehMake: {
        data: [],
        menu: {}
      },
      vehModel: [],
      vehUsg: [],
      statisticsInit: 0,
      statistics: [],
      excessInit: 0,
      excess: [],
      addBenefitsInit: 0,
      addBenefits: [],
      finInst: [],
      campaign: [],
      promotion: [],
      plans: {
        init: 0,
        statistics: [],
        excess: [],
        plans: []
      }
    },
    cargoForm: {
      busCls: undefined,
      tariff: undefined,
      comdty: undefined,
      pack: undefined,
      si: undefined,
      tolerance: undefined,
      siUplift: undefined,
      siCurr: undefined,
      subjectMatter: undefined,
      convy: undefined,
      lcNo: undefined,
      vesNo: undefined,
      voyNo: undefined,
      voyDateType: undefined,
      voyDate: undefined,
      voyArea: undefined,
      portFrom: undefined,
      portTo: undefined,
      voyDesc: undefined,
      csgnName: undefined,
      csgnAdd1: undefined,
      csgnAdd2: undefined,
      csgnAdd3: undefined,
      csgnAdd4: undefined,
      surveyAgt: undefined,
      settlingAgt: undefined,
      clmPayAt: undefined,
      cover: undefined,
      clause: [],
      siDeclared: undefined,
      siBalance: undefined,
      printSi: undefined
    },
    cargoParam: {
      // We will use this flag to determine if we should load params onLoad
      generalLoaded: false,
      shipmentLoaded: false,
      busCls: [],
      tariff: [],
      cover: [],
      convy: [],
      comdty: [],
      pack: [],
      voyArea: [],
      vessel: {
        data: [],
        menu: {}
      },
      voyage: [],
      voyDateType: [],
      ports: [],
      currRates: [],
      surveySettlingAgts: [],
      clauseInit: 0,
      clause: [],
      permittedClause: [],
      finInst: [],
      campaign: [],
      promotion: []
    },
    fireForm: {
      planNo: undefined,
      riskAdd: undefined,
      riskAdd1: undefined,
      riskAdd2: undefined,
      riskAdd3: undefined,
      riskAdd4: undefined,
      riskPostalCode: undefined,
      constrnCls: undefined,
      occupancy: undefined
    },
    fireParam: {
      // We will use this flag to determine if we should load params onLoad
      generalLoaded: false,
      product: [],
      scheme: [],
      optCvr: [],
      finInst: [],
      occupancy: [],
      constrnCls: [],
      campaign: [],
      promotion: [],
      plans: {
        init: 0,
        initErr: [],
        plans: [],
        limitsText: []
      },
      reviewPlan: {
        // Calculation init
        init: 0,
        initErr: []
      }
    },
    maidForm: {
      planNo: undefined,
      gtSalutation: undefined,
      gtName: undefined,
      gtNationality: undefined,
      gtNric: undefined,
      gtDob: undefined,
      gtGender: undefined,
      gtOccupation: undefined,
      gtEmployerName: undefined,
      gtEstAnnualIncome: undefined,
      gtEmail: undefined,
      gtMobileNo: undefined,
      gtTelNo1: undefined,
      gtTelNo2: undefined,
      gtAdd: undefined,
      gtPostalCode: undefined,
      gtAdd1: undefined,
      gtAdd2: undefined,
      gtAdd3: undefined,
      gtAdd4: undefined,
      fwTransNo: undefined,
      fwName: undefined,
      fwNationality: undefined,
      fwPassport: undefined,
      fwDob: undefined,
      fwGender: undefined,
      fwWPNo: undefined,
      fwWPType: undefined
    },
    maidParam: {
      // We will use this flag to determine if we should load params onLoad
      generalLoaded: false,
      product: [],
      scheme: [],
      optCvr: [],
      campaign: [],
      promotion: [],
      plans: {
        init: 0,
        initErr: [],
        plans: [],
        limitsText: []
      },
      reviewPlan: {
        // Calculation init
        init: 0,
        initErr: []
      }
    },
    travelForm: {
      tripType: undefined,
      travelArea: undefined,
      noAdult: undefined,
      noChild: undefined,
      planNo: undefined,
      travelType: undefined,
      insureds: []
    },
    travelParam: {
      // We will use this flag to determine if we should load params onLoad
      generalLoaded: false,
      product: [],
      countries: [],
      travelArea: [],
      campaign: [],
      promotion: [],
      discLdg: [],
      plans: {
        init: 0,
        initErr: [],
        plans: [],
        limitsText: []
      },
      reviewPlan: {
        // Calculation init
        init: 0,
        initErr: []
      }
    },
    paParam: {
      product: [],
      campaign: [],
      promotiom: [],
      occupations: [],
      relationships: [],
      optCvrs: [],
      plans: {
        init: 0,
        initErr: [],
        plans: [],
        limitsText: []
      },
      reviewPlan: {
        init: 0,
        initErr: []
      }
    },
    packageForm: {
      planNo: undefined,
      siAdjustment: undefined
    },
    packageParam: {
      // We will use this flag to determine if we should load params onLoad
      generalLoaded: false,
      product: [],
      scheme: [],
      campaign: [],
      promotion: [],
      plans: {
        init: 0,
        initErr: [],
        plans: [],
        limitsText: []
      },
      reviewPlan: {
        // SI Adjustment init
        adjInit: false,
        // Calculation init
        init: 0,
        initErr: []
      }
    },
    paForm: {
      noAdult: undefined,
      noChild: undefined,
      planNo: undefined,
      paType: undefined,
      insureds: []
    }
  },
  posting: {
    init: 0,
    initErr: [],
    menu: {}
  },
  updateStatus: {
    init: 0,
    initErr: [],
    menu: {},
    statusList: []
  }
}

export default {
  // deep clone here, we need the initialState for resetting of state in SalesOpp
  state: clone(initialState),
  getters,
  mutations,
  actions
}
